import { gql } from "generated/gql"

export const CREATE_PERFORMANCE_SAVED_REPORT_MUTATION = gql(`
  mutation CreatePerformanceSavedReport(
    $name: String!
    $userId: ID!
    $reportKey: String!
    $reportConfig: PerformanceSavedReportConfigInput!
  ) {
    mutationResult:createPerformanceSavedReport (input: {
      name: $name
      userId: $userId
      reportKey: $reportKey
      reportConfig: $reportConfig
    }) {
      id
      errors
      savedReport {
        ...SavedReportFields
      }
    }
  }
`)

export const UPDATE_PERFORMANCE_SAVED_REPORT_MUTATION = gql(`
  mutation UpdatePerformanceSavedReport(
    $id: ID!
    $name: String
    $userId: ID
    $reportConfig: PerformanceSavedReportConfigInput
  ) {
    mutationResult:updatePerformanceSavedReport (input: {
      id: $id
      name: $name
      userId: $userId
      reportConfig: $reportConfig
    }) {
      id
      errors
      savedReport {
        ...SavedReportFields
      }
    }
  }
`)

export const DESTROY_PERFORMANCE_SAVED_REPORT_MUTATION = gql(`
  mutation DestroyPerformanceSavedReport(
    $id: ID!
  ) {
    mutationResult:destroyPerformanceSavedReport (input: {
      id: $id
    }) {
      id
      errors
      savedReport {
        ...SavedReportFields
      }
    }
  }
`)
